import styled, { css } from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "StoreMapstyles__Container",
  componentId: "sc-1i94sna-0"
})(["position:relative;width:100%;"]);
var InteractiveMap = styled.div.withConfig({
  displayName: "StoreMapstyles__InteractiveMap",
  componentId: "sc-1i94sna-1"
})(["background:", ";&::after{content:'';display:block;}", ""], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  switch (props.ratio) {
    case '16-9':
      return css(["&::after{padding-top:56.25%;}"]);

    case '4-3':
      return css(["&::after{padding-top:75%;}"]);

    case '1-1':
      return css(["&::after{padding-top:100%;}"]);

    default:
      return css(["&::after{padding-top:0%;}"]);
  }
});
var GoogleMap = styled.div.withConfig({
  displayName: "StoreMapstyles__GoogleMap",
  componentId: "sc-1i94sna-2"
})(["display:block;position:absolute !important;z-index:z(content);background:", ";padding:0;height:100%;width:100%;top:0;left:0;"], function (props) {
  return props.theme.color.monochrome.light;
});
var MapText = styled.div.withConfig({
  displayName: "StoreMapstyles__MapText",
  componentId: "sc-1i94sna-3"
})(["display:flex;align-items:center;justify-content:center;position:absolute;color:", ";height:100%;width:100%;top:0;left:0;font-size:20px;opacity:0;z-index:1;background-color:rgba(0,0,0,0.5);transition:opacity 0.5s ease-in;&:hover{cursor:pointer;opacity:1;}"], function (props) {
  return props.theme.color.monochrome.white;
});
var StaticMapImage = styled.div.withConfig({
  displayName: "StoreMapstyles__StaticMapImage",
  componentId: "sc-1i94sna-4"
})(["position:absolute;width:100%;height:100%;background-size:100% 100%;top:0;left:0;"]);
export { Container, InteractiveMap, GoogleMap, MapText, StaticMapImage };